;(function() {
  'use strict'

  controller.$inject = ["$scope", "$state", "searchService", "searchTermsService", "locationService"];
  angular.module('app.search').controller('Search', controller)

  /* @ngInject */
  function controller(
    $scope,
    $state,
    searchService,
    searchTermsService,
    locationService
  ) {
    $scope.query = $state.params.query
    $scope.setState = setState
    $scope.onClick = onClick
    $scope.useLocation = useLocation
    $scope.locationAllowed = locationService.isAllowed
    $scope.DEFAULT_ERROR = 'Something went wrong, please try again.'

    function onClick(result) {
      searchService.route(result)
      searchTermsService.create($scope.query, result.type)
    }

    function setState(state, results) {
      $scope.error = null
      $scope.state = state
      $scope.results = results
    }

    function useLocation() {
      $scope.$broadcast('use-location')
    }
  }
})()
